export { apiMindbox } from 'next-flight-server-reference-proxy-loader?id=7f7be1cf22b970357d6ca53fa65d54ae490a3fd0d2&name=apiMindbox!'